
































import AbpBase from "@/lib/abpbase"
import {Component, Prop, Vue} from "vue-property-decorator"
@Component()
export default class Draw extends AbpBase {
	url = XMLHTTP_BASEURL
	@Prop() value:boolean
	@Prop() where:string
	canvasWidth = 1200
	canvasHeight = 600
	canvasMoveUse = false
	canvas:any = {}
	context: any  ={}
	preDrawAry:Array<any> = []
	middleAry:Array<any> = []
	nextDrawAry:Array<any> = []
	imgSrc = ""
	save(){
		let base64Data  = this.canvas.toDataURL("image/png")
		this.imgSrc = base64Data
		var blob = this.dataURItoBlob(base64Data);
		var fd = new FormData();
		fd.append("fileData", blob)
		fd.append("fileName", Date.now() + ".png")
		var xmlHttp = new XMLHttpRequest()
		xmlHttp.open("POST", this.url + 'api/services/app/Helper/FileSave');
		xmlHttp.send(fd);
		let saved = false
		//ajax回调
		xmlHttp.onreadystatechange = () => {
			console.log(xmlHttp.response)
			if (!saved) {
				let response = JSON.parse(xmlHttp.response)
				if (response.result.status === 1 ) {
					this.$emit("save-success", {adress:response.result.objects.imageAddress, where:this.where})
					saved = true
				}
			}

		}
	}
	cancel(){
		this.$emit('input', false)
	}
	dataURItoBlob (base64Data:any) {
		var byteString;
		if (base64Data.split(',')[0].indexOf('base64') >= 0)
			byteString = atob(base64Data.split(',')[1]);
		else
			byteString = unescape(base64Data.split(',')[1]);
		var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
		var ia = new Uint8Array(byteString.length);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		return new Blob([ia], {type: mimeString});
	}

	mounted() {
		// this.canvasWidth = document.body.clientWidth
		// this.canvasHeight = document.body.clientHeight  - 52 -  70
		const canvas:any = this.$refs.canvas
		this.canvas = canvas
		this.context = canvas.getContext('2d')
	}
	canvasDown(e:any) {
		console.log('canvasDown')
		this.canvasMoveUse = true
		const canvas = this.canvas
		// client是基于整个页面的坐标
		// offset是cavas距离顶部以及左边的距离
		// console.log("浏览器宽度", document.body.scrollWidth)
		console.log("canvas", canvas.offsetLeft, canvas.offsetTop)
		console.log("e", e.clientX, e.clientY)
		// console.log("page", page.offsetLeft)
		// console.log("e.target.parentNode", e.target.parentNode.offsetLeft, e.target.parentNode.offsetTop)
		const canvasX = e.clientX - canvas.offsetLeft - document.body.scrollLeft
		const canvasY = e.clientY - canvas.offsetTop - 52 - document.body.scrollTop
		this.setCanvasStyle()
		// 清除子路径
		this.context.beginPath()
		this.context.moveTo(canvasX, canvasY)
		console.log('moveTo', canvasX, canvasY)
		document.onmousemove = (event) => {

		}
		// 当前绘图表面状态
		const preData = this.context.getImageData(0, 0, 1056, 800)
		// 当前绘图表面进栈
		this.preDrawAry.push(preData)
	}
	canvasMove(e:any) {
		if (this.canvasMoveUse) {
			console.log('canvasMove')
			const page = document.getElementsByClassName("single-page-con")[0]
			const left = document.getElementById("left")
			const canvas = this.canvas
			console.log("e.clientX", e.clientX)
			let canvasX
			let canvasY
			if (this.isPc()) {
				canvasX = e.clientX - canvas.offsetLeft - document.body.scrollLeft
				canvasY = e.clientY - canvas.offsetTop - 52 - document.body.scrollTop
			} else {
				canvasX = e.changedTouches[0].clientX - canvas.offsetLeft
				canvasY = e.changedTouches[0].clientY - canvas.offsetTop - 52
			}
			this.context.lineTo(canvasX, canvasY)
			this.context.stroke()
		}
		e.stopPropagation()
		e.preventDefault()
	}
	canvasUp(e:any) {
		console.log('canvasUp')
		const preData = this.context.getImageData(0, 0, 1056, 800)
		if (!this.nextDrawAry.length) {
			// 当前绘图表面进栈
			this.middleAry.push(preData)
		} else {
			this.middleAry = []
			this.middleAry = this.middleAry.concat(this.preDrawAry)
			this.middleAry.push(preData)
			this.nextDrawAry = []
		}
		this.canvasMoveUse = false
	}
	isPc() {
		const userAgentInfo = navigator.userAgent
		const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
		let flag = true
		for (let v = 0; v < Agents.length; v++) {
			if (userAgentInfo.indexOf(Agents[v]) > 0) {
				flag = false
				break
			}
		}
		return flag
	}
	setCanvasStyle() {
		this.context.lineWidth = 4
		this.context.shadowBlur = 2
		this.context.shadowColor = 'black'
		this.context.strokeStyle = 'black'
	}
	visibleChange(value){
		if(!value){
			this.$emit('input',value);
		}
	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/medDoc/parts/draw.vue